@if (type === 'number') {
  <div class="polaris-text-field polaris-text-field--number">
    <span class="polaris-text-field__value">{{ value ?? '0' }}</span>
    <span class="polaris-text-field__step">−</span>
    <span class="polaris-text-field__step">+</span>
  </div>
} @else {
  <div class="polaris-text-field" [class.polaris-text-field--multiline]="multiline">
    @if (value) {
      <span class="polaris-text-field__value">{{ value }}</span>
    } @else {
      <span class="polaris-text-field__placeholder">{{ label }}</span>
    }
  </div>
}
